export function is_segmented(c) {
    return Object.keys(c).includes('Views');
}
export const parse_config = (view_name, Config) => {
    if (typeof Config === 'undefined') {
        throw new Error('No configuration file detected. Please add a link to one in the GIS_CONFIG_FILE setting.');
    }
    let parsed = JSON.parse(JSON.stringify(Config));
    let res;
    if (is_segmented(parsed)) {
        res = resolve_config(parsed, view_name);
    }
    else {
        res = parsed;
        res.view_kind = 'default';
    }
    if (view_name === 'salesratioanalysis') {
        const anyOverlayVisible = res.Layers.some(layer => !layer.isBaseLayer && layer.visible && layer.type !== 'Dynamic');
        if (!anyOverlayVisible) {
            if (res.Layers.length > 0) {
                for (let i = 0; i < res.Layers.length; i++) {
                    const layer = res.Layers[i];
                    if (!layer.isBaseLayer) {
                        res.Layers[i].visible = true;
                        break;
                    }
                }
            }
        }
        res.Layers.map(layer => {
            if (layer.isBaseLayer) {
                layer.visible = false;
            }
            else {
                layer.opacity = 0.2;
            }
        });
    }
    return res;
};
export function resolve_config(c, view_name) {
    var _a, _b, _c, _d, _e, _f, _g;
    let result = {
        ParcelQueryUrl: c.ParcelQueryUrl,
        ParcelQueryUrls: c.ParcelQueryUrls,
        BufferUrl: c.BufferUrl,
        ParcelIdentifierColumn: c.ParcelIdentifierColumn,
        MultipleBaseLayersEnabled: c.MultipleBaseLayersEnabled,
        DisplayLayersListBox: c.DisplayLayersListBox,
        DisplayRightClickPopup: c.DisplayRightClickPopup,
        KmlDownloadEnabled: c.KmlDownloadEnabled,
        authRequired: c.authRequired,
        authUser: c.authUser,
        authPassword: c.authPassword,
        Projections: c.Projections,
        Layers: c.Views[view_name] || c.Views['default'],
        MinResolution: (_a = c.MinResolution) !== null && _a !== void 0 ? _a : null,
        MaxResolution: (_b = c.MaxResolution) !== null && _b !== void 0 ? _b : null,
        view_kind: view_name || 'default',
        Annotations: (_c = c.Annotations) !== null && _c !== void 0 ? _c : {},
        ClickedParcel: (_d = c.ClickedParcel) !== null && _d !== void 0 ? _d : {},
        HoveredParcel: (_e = c.HoveredParcel) !== null && _e !== void 0 ? _e : {},
        SearchedParcel: (_f = c.SearchedParcel) !== null && _f !== void 0 ? _f : {},
        Zoom: (_g = c.Zoom) !== null && _g !== void 0 ? _g : {},
    };
    return result;
}
export function is_grouped(lconf) {
    return Object.keys(lconf).includes('layerGroups');
}
